<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Student Details">
        <v-card flat class="px-2">
          <v-row>
            <v-col cols="12" md="4">
              <label class="font-weight-medium body-2">
                Class <span class="red--text">*</span>
              </label>
              <v-autocomplete
                class="my-0 py-1"
                placeholder="--All Classes--"
                name="classSelect"
                v-model="selectedClassID"
                required
                v-on:change="changeSections()"
                item-value="id"
                :items="classes"
                key="id"
                item-text="name"
                dense
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <label class="font-weight-medium body-2">
                Section <span class="red--text">*</span>
              </label>
              <v-autocomplete
                class="my-0 py-1"
                placeholder="--All Sections--"
                name="sectionSelect"
                v-model="selectedSectionID"
                required
                v-on:change="getStudents(franchiseeID, selectedClassID, selectedSectionID, academicYearID)"
                item-value="id"
                :items="classWiseSections"
                key="id"
                item-text="name"
                dense
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <label class="font-weight-medium body-2">
                Student Status
              </label>
              <v-radio-group dense v-model="activeList" row>
                <v-radio label="Active" :value="'active'"></v-radio>
                <v-radio label="Inactive" :value="'inactive'"></v-radio>
                <v-radio label="Transferred In/Out" :value="'transferred'"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Status</span>
              <v-autocomplete
                dense
                name="student-status"
                class="my-0 py-1"
                placeholder="Select Status"
                v-model="selectedStudentStatus"
                :items="studentStatus"
                item-text="text"
                item-value="value"
                key="text"
                @change="getStudents(franchiseeID, selectedClassID, selectedSectionID, academicYearID, selectedStudentStatus)"
              />
            </v-col>
          </v-row>
        </v-card>

        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-checkbox
              v-model="isTransport"
              label="Transport Opted"
              @change="handleIsTransportChange('isTransport')"
              class="mr-3"
            />
            <v-checkbox
              v-model="managedByCenter"
                label="Transport Managed by Center"
                @change="handleIsTransportChange('managedByCenter')"
              class="mr-3"
            />
            <v-checkbox
              v-model="managedByVendor"
              label="Transport Managed by Vendor"
              @change="handleIsTransportChange('managedByVendor')"
              class="mr-3"
            />
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              @input="searchData"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table :single-expand="true" show-expand item-key="id" disable-pagination :hide-default-footer="true" :headers="headers" :items="students">

        <template v-slot:item.studentEnrollment.studentName="{ item }">
          {{ item.studentEnrollment.studentName }}
          <v-icon
            small
            class="mr-1"
            v-if="item.studentEnrollment.enquiry &&
                  item.studentEnrollment.enquiry.serviceRegistration &&
                  item.studentEnrollment.enquiry.serviceRegistration.isTransport"
            :color="item.studentEnrollment.enquiry.serviceRegistration.managedByVendor ? 'yellow darken-3' : 'grey'"
          >
            mdi-truck
          </v-icon>
        </template>
            <template v-slot:item.status="{ item }">
              {{ item.studentEnrollment.status }}
            </template>

            <template v-slot:item.actions="{ item }">
              <router-link v-if="isWrite" :to="{ name: 'studentEdit', params: { studentId: item.id } }">
                <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small>
                  <v-icon small> mdi-pencil </v-icon>
                </v-btn>
              </router-link>

              <router-link v-if="modules.ViewReportCard" :to="{ name: 'finalReport', params: { studentAdmissionId: item.id } }">
                <v-btn color="darkblue" class="white--text px-2 ml-1 ma-1" min-width="0" small>
                  <v-icon small> mdi-equalizer </v-icon>
                </v-btn>
              </router-link>

              <v-btn
                v-if="modules.studentActiveInactive"
                @click="activeDeactive(item.id)"
                :title="item.isActive ? 'Deactivate' : 'Activate'"
                class="px-2 ml-1 ma-1"
                :color="!item.isActive ? 'info' : 'error'"
                min-width="0"
                small
              >
                <v-icon small>{{ !item.isActive ? 'mdi-restore' : 'mdi-account-cancel' }}</v-icon>
              </v-btn>
               <v-btn
                color="purple"
                class="px-2 ml-1 ma-1"
                min-width="0"
                small
                @click="openLogsDialog(item)"
                :title="'Show All Logs'"
              >
                <v-icon small>mdi-file-document-multiple</v-icon>
              </v-btn>
              <v-btn
                v-if="canShowTransferOption(item)"
                :to="{name:'initiateBranchTransfer', params:{enrollmentCode: item.studentEnrollment.enrollmentCode}}" min-width="0" class="light-green darken-4 white--text px-2 ma-1" small>
                <v-icon small>
                  mdi-swap-horizontal
                </v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-row>
                  <v-col cols="12" md="6" lg="4">
                    <span><b>DOB:</b> {{ item.studentEnrollment.dateOfBirth ? item.studentEnrollment.dateOfBirth : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <span><b>Address:</b> {{ item.studentEnrollment.address ? item.studentEnrollment.address : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>City:</b> <span>{{ item.studentEnrollment.city ? item.studentEnrollment.city : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>State:</b> <span>{{ item.studentEnrollment.state ? item.studentEnrollment.state : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Country:</b> <span>{{ item.studentEnrollment.countryName ? item.studentEnrollment.countryName : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Locality:</b> <span>{{ item.studentEnrollment.locality ? item.studentEnrollment.locality : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Pincode:</b> <span>{{ item.studentEnrollment.pincode ? item.studentEnrollment.pincode : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Father Name:</b> <span>{{ item.studentEnrollment.fatherName ? item.studentEnrollment.fatherName : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Father Mobile:</b>
                    <span>
                      {{ item.studentEnrollment.fatherMobile ? item.studentEnrollment.fatherMobile : '-' }}
                      <v-chip
                        v-if="item.studentEnrollment.user?.isFatherDeleted &&
                             formatTime(item.studentEnrollment.user?.userFatherAccountDeletedAt) === ''"
                        color="blue"
                        small
                        class="ml-2"
                      >
                        {{ "IE App Deactivated" }}
                      </v-chip>
                      <v-chip
                        v-else-if="item.studentEnrollment.user?.isFatherDeleted && formatTime(item.studentEnrollment.user?.userFatherAccountDeletedAt) !== ''"
                        color="red"
                        small
                        class="ml-2"
                      >
                        {{ "IE App Deactivation Initiated" }}
                      </v-chip>
                      <v-chip
                        v-else-if="item.studentEnrollment.fatherMobile"
                        :color="getStatusColor(item.studentEnrollment.enquiry.fatherLogin)"
                        small
                        class="ml-2"
                      >
                        {{ getStatusLabel(item.studentEnrollment.enquiry.fatherLogin) }}
                      </v-chip>
                    </span>
                    <div
                      v-if="item.studentEnrollment.user?.isFatherDeleted && formatTime(item.studentEnrollment.user?.userFatherAccountDeletedAt) !== ''"
                            class="blue--text lighten-1 d-flex align-center mt-1"
                    >
                      {{ formatTime(item.studentEnrollment.user?.userFatherAccountDeletedAt)  }}
                    </div>
                  </v-col>

                  <v-col cols="12" md="6" lg="4">
                    <b>Father Email:</b> <span>{{ item.studentEnrollment.fatherEmailID ? item.studentEnrollment.fatherEmailID : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Mother Name:</b> <span>{{ item.studentEnrollment.motherName ? item.studentEnrollment.motherName : '-' }}</span>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <b>Mother Mobile:</b>
                    <span>
                      {{ item.studentEnrollment.motherMobile ? item.studentEnrollment.motherMobile : '-' }}
                      <v-chip
                        v-if="item.studentEnrollment.user?.isMotherDeleted && formatTime(item.studentEnrollment.user?.userMotherAccountDeletedAt) === ''"
                        color="blue"
                        small
                        class="ml-2"
                      >
                        {{ "IE App Deactivated" }}
                      </v-chip>
                      <v-chip
                        v-else-if="item.studentEnrollment.user?.isMotherDeleted && formatTime(item.studentEnrollment.user?.userMotherAccountDeletedAt) !== ''"
                        color="red"
                        small
                        class="ml-2"
                      >
                        {{ "IE App Deactivation Initiated" }}
                      </v-chip>
                      <v-chip
                        v-else-if="item.studentEnrollment.motherMobile"
                        :color="getStatusColor(item.studentEnrollment.enquiry.motherLogin)"
                        small
                        class="ml-2"
                      >
                        {{ getStatusLabel(item.studentEnrollment.enquiry.motherLogin) }}
                      </v-chip>
                    </span>
                    <div v-if="item.studentEnrollment.user?.isMotherDeleted &&
                            formatTime(item.studentEnrollment.user?.userMotherAccountDeletedAt) !== ''"
                    class="blue--text lighten-1 d-flex align-center mt-1" >
                      {{ formatTime(item.studentEnrollment.user?.userMotherAccountDeletedAt) }}
                    </div>
                  </v-col>

                  <v-col cols="12" md="6" lg="4">
                    <b>Mother Email:</b> <span>{{ item.studentEnrollment.motherEmailID ? item.studentEnrollment.motherEmailID : '-' }}</span>
                  </v-col>

                  <v-col cols="12" class="text-right">
                    <v-btn
                      v-if="item.studentEnrollment.user?.isFatherApproveStatus"
                      color="primary"
                      @click="approveFatherRequest(item)"
                      class="mr-2">
                      Approve Father Request
                    </v-btn>

                    <v-btn
                      v-if="item.studentEnrollment.user?.isMotherApproveStatus"
                      color="primary"
                      @click="approveMotherRequest(item)"
                      class="mr-2">
                      Approve Mother Request
                    </v-btn>

                  </v-col>
                </v-row>
              </td>
            </template>
          </v-data-table>
          <v-col>
            <v-row>
              <v-col cols="4" sm="3">
                <v-select v-model="pageSize" :items="pageSizes" label="Items per Page" @change="handlePageSizeChange"></v-select>
              </v-col>
              <v-col cols="12" sm="9">
                <v-pagination v-model="page" :length="totalPages" :total-visible="10" @input="handlePageChange"></v-pagination>
              </v-col>
            </v-row>
          </v-col>
        </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
     <v-dialog v-model="logsDialog" max-width="900px">
      <v-card>
        <v-card-title>
          <span class="headline">Student Logs</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="logsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 400px; overflow-y: auto;">
          <v-simple-table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Action type</th>
                <th>From Class</th>
                <th>To Class</th>
                <th>Academic Year</th>
                <th>Action By</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="logsData.length === 0">
              <td colspan="7" class="text-center">No Data Found</td>
              </tr>
              <tr v-for="log in logsData" :key="log.id">
                <td>{{ log.date }}</td>
                <td>{{ log.actionType }}</td>
                <td>{{ log.fromClass }}</td>
                <td>{{ log.toClass }}</td>
                <td>{{ log.academicYear }}</td>
                <td>{{ log.from }}</td>
                <td>{{ log.status }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Utils from '@/utils'
import stores from '@/stores'

export default {
  name: 'studentDetails',
  props: ['ClassId', 'FranchiseeId', 'SectionId'],
  components: { MaterialCard, VCardComponent },
  data () {
    return {
      modules: {
        ViewReportCard: this.checkModuleAccess('ViewReportCard'),
        studentActiveInactive: this.checkModuleAccess('studentActiveInactive')
      },
      students: [],
      activeList: 'active',
      search: '',
      isTransport: false,
      managedByCenter: false,
      managedByVendor: false,
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 20, 40],
      franchiseeID: '',
      franchiseeArr: [],
      selectedClassID: '',
      selectedSectionID: '',
      isLoading: false,
      classWiseSections: [],
      classes: [],
      totalStudents: 0,
      academicYearID: '',
      academicYears: [],
      isWrite: false,
      headers: [
        { text: 'Name', value: 'studentEnrollment.studentName', sortable: true },
        { text: 'Class', value: 'studentClass.name', sortable: true },
        { text: 'Section', value: 'studentSection.name', sortable: true },
        { text: 'Enrollment Code', value: 'studentEnrollment.enrollmentCode', sortable: true },
        { text: 'Gender', value: 'studentEnrollment.gender', sortable: false },
        { text: 'Status', value: 'status', sortable: false, align: 'center' },
        { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ],
      studentStatus: constants.STUDENT_EDIT_STATUS,
      selectedStudentStatus: '',
      logsDialog: false,
      logsData: [],
      userRoles: stores.user.roles,
      branchTransferAccessRoles: ['BUSINESS_DEVELOPER'], // zom
      branchTransferAccess: false,
      currentAcademicYear: Utils.getCurrentAcademicYear()
    }
  },
  created: async function () {
    this.page = parseInt(this.$route.params.current)
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getClassList()
    await this.getStudents()
    if (this.ClassId && this.FranchiseeId && this.SectionId) {
      this.franchiseeID = this.FranchiseeId
      this.selectedClassID = this.ClassId
      this.selectedSectionID = this.SectionId
      await this.changeSections()
    }
    this.branchTransferAccess = this.checkBranchTransferAccess()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    }),
    isSuperAdmin: function () {
      return stores.user.me.superAdmin
    }
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    page () {
      this.getStudents()
    },
    activeList: async function () {
      this.page = 1
      this.getStudents(this.franchiseeID, this.selectedClassID, this.selectedSectionID, this.academicYearID)
    },
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYearID: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    },
    selectedClassID: async function (val) {
      await this.getStudents(this.franchiseeID, this.selectedClassID)
    }
  },
  methods: {
    canShowTransferOption (item) {
      return this.branchTransferAccess && item.isActive && this.currentAcademicYear === item?.franchiseeAcademicYear?.academicYear
    },
    checkBranchTransferAccess () {
      return this.userRoles?.some(item => this.branchTransferAccessRoles.includes(item.role)) || this.isSuperAdmin
    },
    approveFatherRequest (item) {
      return http.post(`${constants.API_URL}/api/IEApp/v1/approve/accout-restore`, {
        mobile: item.studentEnrollment.fatherMobile
      })
        .then(response => {
          return this.$dialog.info({
            title: 'Success',
            text: response.message || 'Request Approved'
          }).then(() => {
            this.getStudents()
          })
        })
        .catch(error => {
          console.error('API Error (Father Approval):', error)
          return this.errMsg(error?.response?.message || `An error occurred while processing the request for ${item.studentEnrollment.fatherMobile}`)
        })
    },

    approveMotherRequest (item) {
      return http.post(`${constants.API_URL}/api/IEApp/v1/approve/accout-restore`, {
        mobile: item.studentEnrollment.motherMobile
      })
        .then(response => {
          return this.$dialog.info({
            title: 'Success',
            text: response.message || 'Request Approved'
          }).then(() => {
            this.getStudents()
          })
        })
        .catch(error => {
          return this.errMsg(error?.response?.message || `An error occurred while processing the request for ${item.studentEnrollment.motherMobile}`)
        })
    },

    formatTime (timestamp) {
      let originalDate = moment(timestamp)
      let futureDate = moment(originalDate).add(60, 'days').endOf('day')

      let now = moment().startOf('minute')

      if (futureDate.isBefore(now)) {
        let futureYear = futureDate.year()
        let futureMonth = futureDate.month() + 1
        let futureDay = futureDate.date()
        return `Reactivation by ${String(futureDay).padStart(2, '0')}-${String(futureMonth).padStart(2, '0')}-${futureYear} at 23:59:59`
      }

      return ''
    },
    getStatusColor (status) {
      switch (status) {
        case 'active':
          return 'success'
        case null:
          return 'orange'
        case 'inactive':
          return 'orange'
        default:
          return 'blue'
      }
    },

    getStatusLabel (status) {
      switch (status) {
        case 'active':
          return 'IE App Active'
        case null:
          return 'IE App Inactive'
        case 'inactive':
          return 'IE App Inactive'
        default:
          return 'Unknown'
      }
    },
    activeDeactive: async function (id) {
      this.$dialog.info({
        title: 'Change status',
        text: 'Do you want to update status?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                await http.get(`${constants.API_URL}/api/student/status/${id}`)
                this.okMsg(`Student successfully Updated!`)

                await this.getStudents(this.franchiseeID, this.selectedClassID, this.selectedSectionID, this.academicYearID)
                await this.getClassList()
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                this.errMsg(`Error While updating Student, ${errorMessage}`)
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.students = []
        this.totalStudents = 0
        this.selectedClassID = ''
        this.selectedSectionID = ''
        this.inProgress = false
        await this.getStudents()
        await this.getClassList()
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        let response = await http.get(`${constants.API_URL}/api/student/class-section`)
        const data = response.data
        this.classes = data
        this.sections = data.map(obj => {
          return {
            id: obj.id,
            sections: obj.studentSections
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getStudents: async function (fid = this.franchiseeID, cid = this.selectedClassID, sid = this.selectedSectionID, yr = this.academicYearID, status = this.selectedStudentStatus) {
      let formData = {
        isActive: this.activeList
      }
      if (fid) {
        formData.franchiseeID = fid
      }
      if (cid) {
        formData.classID = cid
      }
      if (sid) {
        formData.sectionID = sid
      }
      if (yr) {
        formData.academicYearID = yr
      }
      if (this.academicYearID) {
        formData.academicYearID = this.academicYearID
      }
      if (this.isTransport) {
        formData.isTransport = true
      }
      if (this.managedByCenter) {
        formData.managedByCenter = true
      }

      if (this.managedByVendor) {
        formData.managedByVendor = true
      }

      try {
        this.isLoading = true
        let url = `${constants.API_URL}/api/V1/student?page=${this.page - 1}&size=${this.pageSize}&search=${this.search}&status=${this.selectedStudentStatus}`
        const result = await http.post(url, formData)
        this.students = result.data.rows
        this.totalPages = result.data.totalPages
        let x = this.students.map(a => {
          if (a.studentEnrollment && a.studentEnrollment.overallStatus) {
            a.studentEnrollment.status = a.studentEnrollment.overallStatus
          } else {
            if (a.studentEnrollment && a.studentEnrollment.enquiry && a.studentEnrollment.enquiry.ieAppEnquiries) {
              a.studentEnrollment.enquiry.ieAppEnquiries.forEach(item => {
                if (item.status === 'pending' && !a.studentEnrollment.status) {
                  a.studentEnrollment.status = item.status
                }
              })
            }
            if (a.studentEnrollment && a.studentEnrollment.enquiry && a.studentEnrollment.enquiry.ieAppEnquiryRegistrations) {
              a.studentEnrollment.enquiry.ieAppEnquiryRegistrations.forEach(item => {
                if (item.status === 'pending' && !a.studentEnrollment.status) {
                  a.studentEnrollment.status = item.status
                }
              })
            }
            if (!a.studentEnrollment.status) {
              a.studentEnrollment.status = '-'
            }
          }
          a.studentEnrollment.dateOfBirth = moment(a.studentEnrollment.dateOfBirth, 'YYYY-MM-DD').format('YYYY-MM-DD')
          a.studentEnrollment.gender =
            a.studentEnrollment.gender === 'MALE' || a.studentEnrollment.gender === 'Male'
              ? 'Boy'
              : a.studentEnrollment.gender === 'FEMALE' || a.studentEnrollment.gender === 'Female'
                ? 'Girl'
                : a.studentEnrollment.gender
          return a
        })
        this.students = x

        // this.totalStudents = res.data.length
      } catch (e) {
        console.log('error in student api', e)
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
      // } else {
      //   this.students = []
      // }
    },
    handlePageChange (value) {
      this.page = value
      this.$router.push({ name: 'studentDetails', params: { current: this.page } })
      this.getStudents(this.franchiseeID, this.selectedClassID, this.selectedSectionID, this.academicYearID)
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getStudents(this.franchiseeID, this.selectedClassID, this.selectedSectionID, this.academicYearID)
    },
    handleIsTransportChange (changedField) {
      if (changedField === 'isTransport') {
        if (this.isTransport) {
          this.managedByCenter = false
          this.managedByVendor = false
        }
      } else if (changedField === 'managedByCenter') {
        if (this.managedByCenter) {
          this.isTransport = false
          this.managedByVendor = false
        }
      } else if (changedField === 'managedByVendor') {
        if (this.managedByVendor) {
          this.isTransport = false
          this.managedByCenter = false
        }
      }

      this.getStudents()
    },
    searchData () {
      if (this.search) {
        this.page = 1
        this.getStudents(this.franchiseeID, this.selectedClassID, this.selectedSectionID, this.academicYearID)
      } else {
        this.getStudents(this.franchiseeID, this.selectedClassID, this.selectedSectionID, this.academicYearID)
      }
    },
    changeSections: async function () {
      try {
        this.isLoading = true
        let sectionarray = this.sections.find(obj => obj.id === this.selectedClassID)
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
        } else {
          this.classWiseSections = []
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    async openLogsDialog (item) {
      this.logsDialog = true
      this.logsData = []
      try {
        const urls = `${constants.API_URL}/api/student/promotion/logs?studentAdmissionID=${item.id}`
        const res = await http.get(urls)
        this.logsData = (res.data || []).map(log => ({
          id: log.id,
          date: log.date
            ? moment(log.date, 'YYYY-MM-DD').format('DD-MMM-YYYY')
            : (log.createdAt ? moment(log.createdAt).format('DD-MMM-YYYY') : '-'),
          actionType: log.actionType || '-',
          fromClass: log.fromClass || '-',
          toClass: log.toClass || '-',
          academicYear: log.academicYear || '-',
          from: log.actionByName
            ? `${log.actionByName}${log.actionByEmail ? ' (' + log.actionByEmail + ')' : ''}`
            : (log.actionByEmail || '-'),
          status: log.status || '-'
        }))
      } catch (e) {
        this.logsData = []
        this.$dialog.error({
          title: 'Error',
          text: 'Failed to fetch logs.'
        })
      }
    }
  }
}
</script>
<style scoped></style>
